export default __webpack_public_path__ + "locales/sq-AL/SocialAuthWelcomeDialog.json?hash=8ec19e4477d43e7a20b062a5d87a4a17";